export const FLOATING_PRICE_VARIANT = {
  SMALL: 'small',
  EXTRA_SMALL: 'extraSmall',
}
